import IframeActivity from "./IframeActivity";

export default function Persuaion() {
    return (
        <IframeActivity
            src="/activities/persuasion/index.html"
            title="Persuasion vs Coercion"
        />
    );
}